import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { BackInStockIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathBackInStockOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.OVERVIEW}
        menuName="Overview"
        icon="box"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathBackInStockAnalytics();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.ANALYTICS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-alt-2"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class InventoryMenu extends React.Component {
  constructor (props) {
    super(props);
    this.inventoryItemsUrl = paths.getPathBackInStockInventoryItems();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.INVENTORY);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.INVENTORY;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.INVENTORY}
        menuName="Inventory"
        icon="layer"
        href={this.inventoryItemsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class SubscribersMenu extends React.Component {
  constructor (props) {
    super(props);
    this.subscribersUrl = paths.getPathBackInStockSubscribers();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.SUBSCRIBERS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.SUBSCRIBERS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.SUBSCRIBERS}
        menuName="Subscribers"
        icon="spreadsheet"
        href={this.subscribersUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class NotificationsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.notificationsUrl = paths.getPathBackInStockNotifications();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.NOTIFICATIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.NOTIFICATIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.NOTIFICATIONS}
        menuName="Notifications"
        icon="message-alt-detail"
        href={this.notificationsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}




@observer
class EmailsMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_BACK_IN_STOCK;
    this.recipientsUrl = utils.appendQueryString(paths.getPathBackInStockEmailRecipients(), qs);
    this.emailDomainsUrl = utils.appendQueryString(paths.getPathEmailDomains(), qs);
    this.emailProfilesUrl = utils.appendQueryString(paths.getPathEmailProfiles(), qs);
    this.emailSettingsUrl = utils.appendQueryString(paths.getPathEmailSettings(), qs);
    this.smtpProfilesUrl = utils.appendQueryString(paths.getPathSmtpProfiles(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.EMAILS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.BACK_IN_STOCK_SIDEBAR.RECIPIENTS,
        label: "Recipients",
        href: this.recipientsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.recipientsUrl),
        isActive: activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.RECIPIENTS
    }, {
        display: true,
        id: constants.BACK_IN_STOCK_SIDEBAR.EMAIL_PROFILES,
        label: "Email Profiles",
        href: this.emailProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailProfilesUrl),
        isActive: activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.EMAIL_PROFILES
    }, {
        display: true,
        id: constants.BACK_IN_STOCK_SIDEBAR.EMAIL_SETTINGS,
        label: "Email Settings",
        href: this.emailSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailSettingsUrl),
        isActive: activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.EMAIL_SETTINGS
    }, {
        display: true,
        id: constants.BACK_IN_STOCK_SIDEBAR.SMTP_PROFILES,
        label: "SMTP Profiles",
        href: this.smtpProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.smtpProfilesUrl),
        isActive: activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.SMTP_PROFILES
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.EMAILS}
        menuName="Emails"
        icon="mail-send"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}


@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathBackInStockConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.BACK_IN_STOCK_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.BACK_IN_STOCK_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.BACK_IN_STOCK_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}



@observer
class BackInStockSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_BACK_IN_STOCK);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    const account = consoleStore.account;

    return (
      <div className="sidebar sidebar-backinstock">
        <div className="sidebar-head">
          <div className="head-icon"><BackInStockIcon /></div>
          <div className="head-title">Back In Stock</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <InventoryMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.INVENTORY}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <SubscribersMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.SUBSCRIBERS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <NotificationsMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.NOTIFICATIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EmailsMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.EMAILS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_BACK_IN_STOCK}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.BACK_IN_STOCK_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_BACK_IN_STOCK}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { BackInStockSidebar };

